export enum FieldSizes {
  THREE = 3,
  FOUR = 4,
  FIVE = 5,
  SIX = 6,
  SEVEN = 7,
  EIGHT = 8,
  NINE = 9,
}

export const sizes = [3, 4, 5, 6, 7, 8, 9];
export const DEFAULT_FIELD_SIZE = FieldSizes.FIVE;
export const DEFAULT_FIELD_SIDE_SIZE = 500;
export const MOBILE_FIELD_SIDE_SIZE = 250;
export const DEFAULT_TIMER_SIZE = 80;
export const MOBILE_TIMER_SIZE = 60;
export const DEFAULT_MSG_SIZE = 65;
export const MOBILE_MSG_SIZE = 25;
export const TABLET_MSG_SIZE = 45;
export const MOBILE_WINDOW_SIZE = 590;
export const TABLET_WORDS_SIZE = 1000;
export const MAX_DESCRIPTION_LENGTH = '3.';
export const MAX_PENALTY = 2;
export const MIN_DESCRIPTION = 5;
export const FIRST_WORDS = ['bar', 'time', 'board', 'aikido', 'barista', 'bookshop', 'buckboard'];
